/**
 * The bill number as a person should read it.
 *
 * The id the server issues already begins with "bill-" — it is built as
 * `bill-<milliseconds>` — so anywhere it was shown under a heading that also
 * said "Bill", the word appeared twice: "Bill No: bill-4395498498" on the
 * printed receipt, "Bill bill-4395498498 generated." in the toast after a sale.
 *
 * The sales ledger already stripped it, inline, in its own copy of this rule.
 * That copy is why the fix was easy to miss elsewhere: the screen most people
 * look at was right, so the ones that were wrong looked like isolated slips
 * rather than one rule applied in one place and forgotten in three.
 *
 * Only the displayed form is trimmed. The id itself is what a bill is stored,
 * looked up and matched by, and is never altered.
 */
export const billNumberOf = (billOrId) => {
  if (typeof billOrId === 'object' && billOrId !== null) {
    const issued = String(billOrId.billNumber || '').trim();
    if (issued) return issued;
    if (billOrId.pending) return 'Pending';
    return '—';
  }

  if (typeof billOrId === 'string' && billOrId.trim()) {
    const str = billOrId.trim();
    if (!str.toLowerCase().startsWith('bill-')) {
      return str;
    }
  }

  return '—';
};
